import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

import { SendTypesUi } from 'src/app/configs/send-type-ui.config';
import { SendTypes } from '../api/models';

@Directive({
  selector: '[sendTypeStyle]',
  standalone: true,
})
export class SendTypeDirective {
  @Input('sendTypeStyle') type: SendTypes;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'tw-text-sm tw-font-bold text-';
    switch (this.type) {
      case SendTypes.ApiP2P:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.ApiP2P
        ).colorName;
        break;
      case SendTypes.ApiSingle:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.ApiSingle
        ).colorName;
        break;
      case SendTypes.Bulk:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Bulk
        ).colorName;
        break;
      case SendTypes.Bulk2:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Bulk2
        ).colorName;
        break;
      case SendTypes.Club:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Club
        ).colorName;
        break;
      case SendTypes.Dynamic:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Dynamic
        ).colorName;
        break;
      case SendTypes.OTP:
        classList += SendTypesUi.find((a) => a.type == SendTypes.OTP).colorName;
        break;
      case SendTypes.P2P:
        classList += SendTypesUi.find((a) => a.type == SendTypes.P2P).colorName;
        break;
      case SendTypes.Phonebook:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Phonebook
        ).colorName;
        break;
      case SendTypes.Single:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Single
        ).colorName;
        break;
      case SendTypes.Smart:
        classList += SendTypesUi.find(
          (a) => a.type == SendTypes.Smart
        ).colorName;
        break;

      default:
        break;
    }
    return classList;
  }
}
